import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'

export class MarkQuizAsReadyUseCase {
  private learningQuizRepository: IQuizRepository

  constructor(learningQuizRepository: IQuizRepository) {
    this.learningQuizRepository = learningQuizRepository
  }

  async execute(quizId: number): Promise<Quiz> {
    return await this.learningQuizRepository.markQuizAsReady(quizId)
  }
}
